export default __webpack_public_path__ + "static/media/POR.0defa2ab.svg";